import { render, staticRenderFns } from "./ConfigTasks.vue?vue&type=template&id=5b502262&scoped=true&"
import script from "./ConfigTasks.vue?vue&type=script&lang=js&"
export * from "./ConfigTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b502262",
  null
  
)

export default component.exports